let initialized = false;

/* eslint-disable */

export default {
  init(pixelId, options = {}) {
    if (initialized) return;

    !(function (e) {
      if (!e.pintrk) {
        const n = (e.pintrk = function () {
          n.queue.push(Array.prototype.slice.call(arguments));
        });
        n.queue = [];
        n.version = "3.0";

        const t = document.createElement("script");
        t.async = true;
        t.src = "https://s.pinimg.com/ct/core.js";

        const r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r);
      }
    })(window);

    // Load pixel
    window.pintrk("load", pixelId, options);

    // Track page view

    initialized = true;
  },

  /* eslint-enable */

  track(event, data = null) {
    if (!initialized) return;
    window.pintrk("track", event, data); // eslint-disable-line
  },
  isInitialized() {
    return initialized;
  },
};
